export const CardData = [
  {
    title: "Juba Mall",
    desc: "Welcome to the Juba Mall Administrator Dashboard.",
  },
  {
    title: "App",
    desc: "Control Application features and performance.",
    path: "/app/banner",
  },
  {
    title: "Products",
    desc: "Commodity management (Upload, Edit, Delete) products.",
    path: "/products",
  },
  {
    title: "Orders",
    desc: "Overview & track customer orders, payments and delivery.",
    path: "/orders",
  },
];
